import { type Recursive, isRS } from '@/utils';
import {
  ACCOUNT_TITLE_CODE_LENGTH,
  COST_CODE_LENGTH,
  EXPENDITURE_BUDGET_JURISDICTION_CODE_LENGTH,
  EXPENDITURE_BUDGET_ORGANIZATION_CODE_LENGTH,
  POLICY_CODE_LENGTH,
  accountTypeCodeLength,
  expenditureNatureCodeLength,
  expenditurePurposeCodeLength,
  revenueNatureCodeLength,
} from './code-max-length';

export const fillZeroToAccountType = (value: number | string) => {
  return value.toString().padStart(accountTypeCodeLength(), '0');
};
export const fillZeroToExpenditurePurpose = ({
  value,
  isLevel2,
  isMajorMatter,
}: {
  value: number | string;
  isLevel2?: boolean;
  isMajorMatter?: boolean;
}) => {
  return isRS() && isLevel2 && !isMajorMatter
    ? value
    : value
        .toString()
        .padStart(expenditurePurposeCodeLength(isMajorMatter), '0');
};
export const fillZeroToExpenditureNature = (
  value: number | string,
  isLevel2?: boolean,
) => {
  return isRS()
    ? value
    : value.toString().padStart(expenditureNatureCodeLength(isLevel2), '0');
};
export const fillZeroToRevenueNature = (
  value: number | string,
  isLevel4?: boolean,
) => {
  return value.toString().padStart(revenueNatureCodeLength(isLevel4), '0');
};
export const fillZeroToPolicyForRS = (value: number | string) =>
  value.toString().padStart(POLICY_CODE_LENGTH, '0');

export const fillZeroToExpenditureBudgetJurisdiction = (
  value: number | string | undefined,
) => {
  return value
    ?.toString()
    .padStart(EXPENDITURE_BUDGET_JURISDICTION_CODE_LENGTH, '0');
};
export const fillZeroToExpenditureBudgetOrganization = (value: number) => {
  return value
    .toString()
    .padStart(EXPENDITURE_BUDGET_ORGANIZATION_CODE_LENGTH, '0');
};

export const fillZeroToCost = (value: number) => {
  return value.toString().padStart(COST_CODE_LENGTH, '0');
};
export const fillZeroToAccountTitle = (value: number) => {
  return value.toString().padStart(ACCOUNT_TITLE_CODE_LENGTH, '0');
};

export const padZeroToLeft = <
  T extends { name: string; code: string | number; level?: number },
  R extends Recursive<T>,
>(
  arr: R[],
  maxLength: number,
  exception?: { level: number; maxLength: number },
): R[] => {
  return arr.map((obj) => {
    const children = obj.children;
    const value = {
      ...obj,
      name: `${obj.code
        .toString()
        .padStart(
          exception && exception.level === obj.level
            ? exception.maxLength
            : maxLength,
          '0',
        )}: ${obj.name}`,
    };
    if (!children?.length) {
      return { ...value };
    }
    return {
      ...value,
      children: padZeroToLeft(children, maxLength, exception),
    };
  });
};
